import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
	addressLine1: Yup.string().required('This is required.'),
	addressLine2: Yup.string(),
	city: Yup.string().required('This is required.'),
	state: Yup.string().required('This is required.'),
	postalCode: Yup.string()
		.max(5, 'Please enter 5 digits')
		.required('This is required.'),
});
